import {standardChart} from './utilities';

export const figure8 = { 
      ...standardChart,

      chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: '400px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#cc99ff', '#ed7c31', '#a5a5a5', '#ffc000', '#8f7eab', '#70ad47', '#00b0f0'],
      tooltip: {
        pointFormat: '{series.val} : <b>{point.val}</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.val}</b>',
                distance: -50,
            }
        }
    },
    series: [{
        name: '',
        colorByPoint: true,
        data: [{
            name: 'Océanie',
            y: 1,
            val: 5
        }, {
            name: 'África subsahariana',
            y: 31,
            val: 724
        }, {
            name: 'América del Norte y Europa',
            y: 4,
            val: 98
        }, {
            name: 'Asia oriental y Asia sudoriental',
            y: 11,
            val: 256,
        }, {
            name: 'Asia central y Asia meridional',
            y: 36,
            val: 863
        }, {
            name: 'América Latina y el Caribe ',
            y: 11,
            val: 267
        }, {
            name: 'África septentrional y Asia occidental',
            y: 6,
            val: 154
        }]
    }]
}
